import { Box } from "@mui/material";
import { alpha } from "@mui/material/styles";
import type { FC } from "react";
import { INK } from "../../../../theme/tokens";
import { useStatusColor } from "../hooks/useThresholdStatus";
import type { ThresholdConfig } from "../types";
import { Item } from "./Item";
import type { TableDiffItem } from "./type";

type ItemListProps = {
	items: TableDiffItem[];
	wantedWrapper?: (val: number) => React.ReactNode;
	actualWrapper?: (val: number) => React.ReactNode;
	threshold: ThresholdConfig;
	higherIsBetter?: boolean;
	closestToTargetIsBest?: boolean;
};

export const ItemList: FC<ItemListProps> = ({ items, wantedWrapper, actualWrapper, threshold, higherIsBetter = true, closestToTargetIsBest = false }) => {
	const getStatusColor = useStatusColor({
		threshold,
		mode: closestToTargetIsBest ? "closestToTarget" : higherIsBetter ? "higherIsBetter" : "lowerIsBetter",
	});

	return (
		<Box
			sx={{
				flex: 1,
				display: "flex",
				flexDirection: "column",
			}}
		>
			{items.length === 0 ? (
				<Box
					sx={{
						color: alpha(INK.SECONDARY, 0.5),
						fontSize: 14,
						fontStyle: "italic",
					}}
				>
					No items
				</Box>
			) : (
				items.map((item) => {
					const percentage = item.percentageOfTarget ?? (item.actual / item.wanted) * 100;
					const { status, color } = getStatusColor(percentage);

					return <Item key={item.title} item={item} status={status} color={color} wantedWrapper={wantedWrapper} actualWrapper={actualWrapper} />;
				})
			)}
		</Box>
	);
};
